// extracted by mini-css-extract-plugin
module.exports = {"container":"Tag_container__24ERb","default":"Tag_default__2U3si"};